import { LoginForm } from '../login';

(function () {
    // Core form
    // ------------------------------------------
    //input text... dectect change... add floating label class
    $(".input-wrap input[type=text], .input-wrap input[type=password]").on('input', function () {
        var $this = $(this);
        var $wrap = $(this).closest('.input-wrap');
        // check if the field contains text...
        if ($this.val()) {
            if (!$wrap.hasClass("floating-label")) {
                $wrap.addClass("floating-label");
            }
        } else {
            $wrap.removeClass("floating-label");
        }
    });

    function dropDownSelection(className, payment_method) {
        var appliedClass = "#" + payment_method + "-form .select-style-wrap." + className;
        var $selectText = $(appliedClass + " .select-text");
        //set intial text value
        $selectText.html($(appliedClass + " select :selected").text());

        //listen for changes and update text
        $(appliedClass + " select").change(function () {
            $(this).closest(appliedClass).addClass("floating-label");
            // remove placeholder text styling
            if ($selectText.hasClass("initial-style")) {
                $selectText.removeClass("initial-style");
            }
            // update text
            $selectText.html($(appliedClass + " select :selected").text());
        });
    }

    $.each(["cyber_source", "worldpay_cc", "stripe_payments"], function (index, payment_method) {
        dropDownSelection("expiration-month", payment_method);
        dropDownSelection("expiration-year", payment_method);
        dropDownSelection("country", payment_method);
        dropDownSelection("state", payment_method);
        dropDownSelection("province", payment_method);
    });

    // Accordion toggle logic
    //------------------------------------------
    $("input[type='radio']").on("change", toggleAccordion);

    function toggleAccordion() {
        // close unchecked
        $("input[type='radio']:not(:checked)").siblings(".accordion-row-content").slideUp(300);
        //open checked
        $("input[type='radio']:checked").siblings(".accordion-row-content").slideDown(300);
    }

    // reveal billing address info
    //------------------------------------------
    function revealBillingAddress(){
      $(".billing-information").slideDown(600, function() {
        // Animation complete focus input
        $("#billing_first_name").focus();
      });
    }

    // CVV number popup
    //------------------------------------------
    $(".cvv-help-icn").on("click", toggleCvvPopup);
    $(".cvv-number-popup .close-btn").on("click", toggleCvvPopup);

    function toggleCvvPopup() {
        $(".cvv-number-popup").fadeToggle(200);
    }

    // (mobile) order summary show/hide logic
    //------------------------------------------
    var $asideMobileHeader = $(".aside-mobile-header");
    var $order = $(".order");

    $asideMobileHeader.on("click", toggleOrderSummary);

    function toggleOrderSummary() {
        $asideMobileHeader.toggleClass("open");
        $order.slideToggle(300, cleanOrderSummary);
    }
    // when the oder summary slides up (returned to it's default state) remove the inline styles created by slide toggle
    function cleanOrderSummary() {
        if (!$asideMobileHeader.hasClass("open")) {
            $order.removeAttr('style');
        }
    }

    // Everything is loaded... initalize the page
    //------------------------------------------

    //Login Handler
    LoginForm.setup('.order-login-form')

    // TOS and privacy popups
    $(document).on('click', '.privacy-popup-link', function(e){
        e.preventDefault();
        e.stopPropagation();
        const privacyPopupLink = $(e.target);
        const remoteUrl = privacyPopupLink.attr('data-href');

        showPopup('.privacy-popup', {remote: remoteUrl});
    });

    $(document).on('click', '.privacy-popup .pop-close-btn', function() {
        hidePopup('.privacy-popup')
    });

    $(document).on('click', '.tos-popup-link', function(e){
        e.preventDefault();
        e.stopPropagation();
        const tosPopupLink = $(e.target);
        const remoteUrl = tosPopupLink.attr('data-href');

        showPopup('.tos-popup', {remote: remoteUrl});
    });

    $(document).on('click', '.tos-popup .pop-close-btn', function() {
        hidePopup('.tos-popup')
    });

    function showPopup(popupSelector, options) {
        if(typeof options === undefined) {
            options = {}
        }

        const popup = $(popupSelector);
        popup.addClass("show");
        if(options.remote) {
            $('.pop-content iframe', popup).attr("src", options.remote);
        }
        disableBodyScroll()
    }

    function hidePopup(popupSelector) {
        const popup = $(popupSelector);
        popup.removeClass("show");
        enableBodyScroll();
    }

    function enableBodyScroll() {
        $("body").removeClass("pop-open-no-scroll"); // restore scrolling
    }

    function disableBodyScroll() {
        $("body").addClass("pop-open-no-scroll"); // disable scrolling beneath the popup
    }

    function parentLogin(e) {
        e.preventDefault();
        var $form = $(e.target);
        $.ajax($(this).attr('action'), {
            async: true,
            type: 'POST',
            data: $form.serialize()
        }).done(function (response) {
            if (response.message != null) {
                var errorElement = $form.find("#message");
                errorElement.html(errorElement.children()).append(response.message);
                errorElement.show().addClass("show");
                errorElement.siblings("input").addClass("invalid");
            } else {
                $('#playerAccountList').html(response);
                $('#parentLoginForm').hide();
                $('#playerAccountsListForm').show();
            }
        });
        return false;
    }

    $('#parentLoginForm').on("submit", parentLogin);

    // Select First Payment type by deafult
    window.onload = function(){
        var $firstAccordion = $('.accordion.payment-method .accordion-row:first-of-type');
        $firstAccordion.children('input[type="radio"]').attr('checked', true);
        $firstAccordion.children('.accordion-row-content').slideDown(300);
    }

    if(window.location.pathname === '/order-details'){
        history.pushState({}, "Membership", "");
        window.onpopstate = function() {
          window.location = "/join";
        };
    }
})();
